// Centro do Brasil, usado quando o endereço não é localizado e o usuário precisa marcar o ponto no mapa
export const MAPA_CENTRO_PADRAO = [-14.235, -51.9253];
export const MAPA_ZOOM_PADRAO = 4;
export const MAPA_ZOOM_ENDERECO = 20;

// Converte latitude/longitude (string com vírgula ou ponto) em [lat, lng]. Retorna null se inválido.
export function parseCoordenadas(latitude, longitude) {
  const lat = parseFloat(String(latitude ?? "").replace(",", "."));
  const lng = parseFloat(String(longitude ?? "").replace(",", "."));
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lat, lng];
}
